/* OWS windmill powder-coat image and thumbnail filtering. */
(() => {
  const finishMap = {
    'Galvanized Finish': 'Galvanized Finish',
    Bronze: 'Bronze Finish',
    Black: 'Black Finish',
    'Forest Green': 'Forest Green Finish',
    'Red & White': 'Red White Finish',
    'Blue & White': 'Blue White Finish',
    'Green & Yellow': 'Green Yellow Finish',
    '250th Anniversary': '250th Anniversary Finish',
  };

  const finishAlts = new Set(Object.values(finishMap));
  let isUpdating = false;

  function setThumbnailVisibility(thumbnail, visible) {
    if (!thumbnail) return;
    const properties = ['position', 'visibility', 'opacity', 'pointerEvents', 'width', 'height', 'margin', 'padding', 'overflow'];

    if (visible) {
      properties.forEach((property) => {
        thumbnail.style[property] = '';
      });
      return;
    }

    Object.assign(thumbnail.style, {
      position: 'absolute',
      visibility: 'hidden',
      opacity: '0',
      pointerEvents: 'none',
      width: '0px',
      height: '0px',
      margin: '0px',
      padding: '0px',
      overflow: 'hidden',
    });
  }

  function filterThumbnails(selectedAlt) {
    document.querySelectorAll('.product__thumbs-item, .thumbnail-list__item').forEach((thumbnail) => {
      const alt = (thumbnail.querySelector('img')?.alt || '').trim();
      if (finishAlts.has(alt)) setThumbnailVisibility(thumbnail, alt === selectedAlt);
    });
  }

  function getGallery() {
    return document.querySelector('.product__media-gallery-viewer');
  }

  function goToImage(altText) {
    const gallery = getGallery();
    const swiper = gallery?.swiper;
    if (!swiper) return;

    const images = [...gallery.querySelectorAll('.product__media-item img')];
    const index = images.findIndex((image) => (image.alt || '').trim() === altText);
    if (index >= 0) swiper.slideTo(index);
  }

  function applyFinish(value) {
    const targetAlt = finishMap[value] || 'Galvanized Finish';
    filterThumbnails(targetAlt);
    window.setTimeout(() => {
      if (value === 'Galvanized Finish' || !finishMap[value]) {
        getGallery()?.swiper?.slideTo(0);
      } else {
        goToImage(targetAlt);
      }
    }, 100);
  }

  function isFinishControl(element) {
    return element.matches(
      'input[name="Powder Coat Added"], input[name="Head Powder Coat Added"], select[name="Powder Coat Added"], select[name="Head Powder Coat Added"]',
    );
  }

  document.addEventListener('change', (event) => {
    if (isUpdating || !isFinishControl(event.target)) return;
    isUpdating = true;
    applyFinish(event.target.value);
    window.setTimeout(() => {
      isUpdating = false;
    }, 400);
  });

  function initialize() {
    const activeControl = document.querySelector(
      'input[name="Powder Coat Added"]:checked, input[name="Head Powder Coat Added"]:checked, select[name="Powder Coat Added"], select[name="Head Powder Coat Added"]',
    );

    isUpdating = true;
    applyFinish(activeControl?.value && activeControl.value !== 'None' ? activeControl.value : 'Galvanized Finish');
    window.setTimeout(() => {
      isUpdating = false;
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
